import React, { useState, Fragment } from 'react';
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import stripe_logo from "../../../../../assets/stripe_logo.jpg";
export default function OpenAccount({
    toggle,
    visible,
    createAccount,
    deleteAccount,
    isConnected
}) {
    let button = <Button outline size="lg" onClick={() => { createAccount(); }} style={{ width: '100%', borderRadius: '6px' }}> Connect Account</Button>;

    return (
        <Fragment>
            <Modal
                isOpen={visible}
                toggle={toggle}
                size="lg"
                style={{ maxWidth: '50%' }}
            >
                <ModalHeader toggle={toggle} style={{ backgroundcolor: "blue" }}>
                    <div className="col-md-12" style={{ padding: "4%" }}>
                        <img
                            src={stripe_logo}
                            style={{ height: "50px" }} />
                        <br />
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <div className="col-md-1"></div>
                        <div className="col-md-8">
                            <div className="form-check">
                                <input className="form-check-input" type="radio" value="accounts" disabled checked />
                                <label className="form-check-label" htmlFor="accounts">
                                    Accept credit and debit card payments from the customers around the world.Available for sites NewZeland
                                </label>
                            </div>
                            <br />
                            <div className="form-check">
                                <input className="form-check-input" type="radio" value="singup" disabled checked />
                                <label className="form-check-label" htmlFor="singup">
                                    Simple signup through online registration form
                                </label>
                            </div>
                            <br />
                            <div className="form-check">
                                <input className="form-check-input" type="radio" value="fees" disabled checked />
                                <label className="form-check-label" htmlFor="fees">
                                    Fess vary according to processing plan. No setup fees.
                                </label>
                            </div>
                            <br />
                        </div>
                        <div className="col-md-1"></div>
                    </Row>
                    <br />
                    <Row>
                        <div className="col-md-7"></div>
                        <div className="col-md-5">
                            {button}

                        </div>
                    </Row>
                </ModalBody>
            </Modal>
        </Fragment >
    );
}